import i18n from '@app/i18n';
import { VisibilityType } from '@data/sdk/match';

export const getQuestionVisibilityOptions = () => [
  { label: i18n.t('admin:question_visibility.default'), value: VisibilityType.Default },
  { label: i18n.t('admin:question_visibility.first'), value: VisibilityType.First },
  { label: i18n.t('admin:question_visibility.hidden'), value: VisibilityType.Hidden },
];
